.userImage {
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;

  &.round {
    .image,
    .label {
      border-radius: 50%;
      background-color: var(--primary-600);
    }
  }

  .edit {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 1.875rem;
    height: 1.875rem;

    svg {
      width: 1rem;
      height: 1rem;
    }
  }

  .image {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    object-fit: cover;
  }

  .label {
    position: relative;
    width: 100%;
    height: 100%;
  }

  label {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  input {
    opacity: 0;
    position: absolute;
    width: 0.1px;
    height: 0.1px;
  }
}
